var ADOLOPMENT_OPTIONS, AGE, BOOLEAN_OPTIONS_WITH_NOT_REPORTED, CERTAINTIES_OF_EVIDENCE, GRADING_OPTIONS, INTENDED_POPULATIONS, INTERVENTION_TYPES, PCC_MODULES, PLANETARY_HEALTH, PLANETARY_HEALTH_RECOMMENDATION_FORM_ITEMS, PLUS, PROGRESS, PlainLanguageLinksField, RECOMMENDATION_INTENTS, RECOMMENDATION_INTENTS_PLANETARY_HEALTH, RECOMMENDATION_INTENTS_WHO, RECOMMENDATION_STRENGTHS, SYMPTOMS, VACCINATION, _ref;

PlainLanguageLinksField = require('components/covid_extraction_form/plain_language_links_field');

_ref = require('lib/extraction_form_helper'), ADOLOPMENT_OPTIONS = _ref.ADOLOPMENT_OPTIONS, AGE = _ref.AGE, BOOLEAN_OPTIONS_WITH_NOT_REPORTED = _ref.BOOLEAN_OPTIONS_WITH_NOT_REPORTED, CERTAINTIES_OF_EVIDENCE = _ref.CERTAINTIES_OF_EVIDENCE, GRADING_OPTIONS = _ref.GRADING_OPTIONS, INTENDED_POPULATIONS = _ref.INTENDED_POPULATIONS, INTERVENTION_TYPES = _ref.INTERVENTION_TYPES, PCC_MODULES = _ref.PCC_MODULES, PLUS = _ref.PLUS, PROGRESS = _ref.PROGRESS, RECOMMENDATION_INTENTS = _ref.RECOMMENDATION_INTENTS, RECOMMENDATION_INTENTS_WHO = _ref.RECOMMENDATION_INTENTS_WHO, RECOMMENDATION_STRENGTHS = _ref.RECOMMENDATION_STRENGTHS, SYMPTOMS = _ref.SYMPTOMS, VACCINATION = _ref.VACCINATION;

RECOMMENDATION_INTENTS_PLANETARY_HEALTH = _.map(['prevention', 'diagnosis', 'treatment'], function(value) {
  return {
    value: value,
    text: $.t("es:recommendations.metadataExtractionForm.values.recommendationModule." + value)
  };
});

PLANETARY_HEALTH = _.map(["pollution", "greenhouse", "biosphere", "landuse", "freshwater", "nutrients", "ocean", "aerosols", "ozone_depletion"], function(value) {
  return {
    value: value,
    text: $.t("es:recommendations.metadataExtractionForm.values.planetaryHealth." + value)
  };
});

PLANETARY_HEALTH_RECOMMENDATION_FORM_ITEMS = {
  main: [
    {
      fieldKey: 'age',
      type: 'multiSelect',
      options: AGE
    }, {
      fieldKey: 'recommendationModule',
      type: 'select',
      options: RECOMMENDATION_INTENTS_PLANETARY_HEALTH
    }, {
      fieldKey: 'canPCCModule',
      type: 'select',
      options: PCC_MODULES
    }, {
      fieldKey: 'planetaryHealth',
      type: 'multiSelect',
      options: PLANETARY_HEALTH
    }, {
      fieldKey: 'publicationDate',
      type: 'date'
    }, {
      fieldKey: 'authors',
      type: 'editorText'
    }, {
      fieldKey: 'recommendationIntentWHO',
      type: 'select',
      options: RECOMMENDATION_INTENTS_WHO,
      featureSwitch: 'show_who_covid_intents'
    }, {
      fieldKey: 'coexistingCondition',
      type: 'text',
      placeholderFromI18n: true,
      helperTextFromI18n: true
    }, {
      fieldKey: 'intendedPopulation',
      type: 'multiSelect',
      options: INTENDED_POPULATIONS
    }, {
      fieldKey: 'informal',
      type: 'switcher'
    }, {
      fieldKey: 'research',
      type: 'switcher'
    }, {
      fieldKey: 'reportedAsGPS',
      type: 'switcher'
    }, {
      fieldKey: 'adolopment',
      type: 'select',
      options: ADOLOPMENT_OPTIONS
    }, {
      fieldKey: 'transformed',
      type: 'switcher'
    }, {
      fieldKey: 'gradingEvidenceMethod',
      type: 'radioOptions',
      options: GRADING_OPTIONS,
      placeholderFromI18n: true,
      withOther: true
    }, {
      fieldKey: 'sofSupplemented',
      type: 'switcher'
    }, {
      fieldKey: 'etdModified',
      type: 'switcher'
    }, {
      fieldKey: 'certaintyOfEvidence',
      type: 'selectWithOther',
      options: CERTAINTIES_OF_EVIDENCE,
      placeholderFromI18n: true
    }, {
      fieldKey: 'strengthOfRecommendation',
      type: 'selectWithOther',
      options: RECOMMENDATION_STRENGTHS,
      placeholderFromI18n: true
    }, {
      fieldKey: 'expertComment',
      type: 'editorText'
    }, {
      fieldKey: 'plainLanguageSummaryDescription',
      type: 'editorText'
    }, {
      fieldKey: 'plainLanguageSummary',
      type: 'custom',
      customWithArray: true,
      component: PlainLanguageLinksField,
      showClear: false
    }, {
      fieldKey: 'relatedRecommendationLinks',
      type: 'custom',
      customWithArray: true,
      component: PlainLanguageLinksField,
      showClear: false,
      additionalProps: {
        addBtnLabel: $.t('/actions.add_related_recommendation')
      }
    }, {
      fieldKey: 'individualRecommendation',
      type: 'text',
      placeholderFromI18n: true
    }, {
      fieldKey: 'evidenceTableUrl',
      type: 'text',
      placeholderFromI18n: true
    }, {
      fieldKey: 'loveUrl',
      type: 'text',
      placeholderFromI18n: true
    }, {
      fieldKey: 'emlUrl',
      type: 'multiText',
      placeholderFromI18n: true,
      addValueLabel: $.t('actions.add_link')
    }, {
      fieldKey: 'symptoms',
      type: 'multiSelect',
      options: SYMPTOMS
    }, {
      fieldKey: 'vaccination',
      type: 'select',
      options: VACCINATION
    }, {
      fieldKey: 'interventionTypes',
      type: 'select',
      options: INTERVENTION_TYPES
    }, {
      fieldKey: 'hospitalization',
      type: 'radioOptions',
      options: BOOLEAN_OPTIONS_WITH_NOT_REPORTED
    }
  ],
  progress: [
    {
      fieldKey: 'progress',
      type: 'multiSelect',
      options: PROGRESS
    }, {
      fieldKey: 'plus',
      type: 'multiSelect',
      options: PLUS
    }, {
      fieldKey: "progressPlus",
      type: 'text'
    }
  ],
  seo: [
    {
      fieldKey: 'keywords',
      type: 'text',
      placeholderFromI18n: true
    }
  ]
};

module.exports = {
  PLANETARY_HEALTH_WORKSPACE_ID: "o_planetary_health_0",
  PLANETARY_HEALTH_RECOMMENDATION_FORM_ITEMS: PLANETARY_HEALTH_RECOMMENDATION_FORM_ITEMS
};
